import React from 'react';
import SentenceForm from "../../components/common/SentenceForm";
import Container from "@material-ui/core/Container";
import ScrollableAnchor from "react-scrollable-anchor";
import {DropzoneArea} from "material-ui-dropzone";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {
    answerState,
    etcReturnFileState,
    menuCheckSelector,
    selectedMenuItemState,
    surveyDataState, userState
} from "../../state/globalState";
import {fileUploadToAzureStorage, findFilesByFileGcd} from "../../lib/api/file";
import DropzoneFileItem from "../common/DropzoneFileItem";

/**
 * 설문 문항 컴포넌트
 */
const Survey16 = (props) => {
    const userInfo = useRecoilValue(userState);
    const surveyData = useRecoilValue(surveyDataState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);
    const [etcReturnFiles, setEtcReturnFiles] = useRecoilState(etcReturnFileState);
    const ref = props.compRef[13];

    const setFocus = () => {
        ref.focus();
    }

    const getFiles = async (admnNo, stdYear) => {
        const { data } = await findFilesByFileGcd(admnNo, stdYear);
        if (data.success) {
            const files = data.payload.filter((file) => (file.kognrFileGcd === "HC050006"))
            setEtcReturnFiles(files);
        }
    }

    const handleChange = async (files) => {
        if (!files || files.length === 0) return;

        setSelectedMenuItem('SURVEY_34');

        const opts = {
            stdYear: userInfo.stdYear,
            admnNo: userInfo.admnNo,
            attcFileBizGcd: "hc056002",
            kognrFileGcd: "HC050006",
        }

        for (const fileObj of files) {
            const { data } = await fileUploadToAzureStorage(fileObj, opts);
            if (data.success) {
                const { resultCode, resultMsg } = data.payload;
                if (resultCode === "0000") {
                    setMenuCheck(true);
                } else {
                    console.error("File upload failed:", resultMsg);
                }
            }
        }

        await getFiles(userInfo.admnNo, userInfo.stdYear);
    };

    const handleDelete = (deletedFile) => {
        const filteredList = etcReturnFiles.filter((item) => item.name !== deletedFile.name);
        // dispatch(setKognrEctFile(filteredList));
    };

    return (
        <>
            <ScrollableAnchor id={"112"}>
                <div>
                    <Container style={{background: 'transparent', marginBottom: '10px'}}>
                        <SentenceForm
                            title={surveyData[112].title}
                            sentences={surveyData[112].questions}
                            step={112}
                        />
                        <div>
                            <div>
                              <div className="blockquote-box">
                                <div>
                                  [첨부파일 예시]
                                </div>
                                <div>
                                  1) 간소화자료에서 누락된 기부금의 경우 - 기부금 명세서, 기부금 영수증 등
                                </div>
                                <div>
                                  2) 간소화자료에서 누락된 의료비의 경우 - 연말정산제출용 영수증(시력보정용 안경 또는 렌즈 구입비용, 난임치료비용,
                                </div>
                                <div>
                                  &nbsp;&nbsp;&nbsp;&nbsp;장애인 보장구 구입 및 임차비용 등)
                                </div>
                                  <div>
                                    3) 벤처투자조합 출자 또는 투자금의 경우 - 출자 등 소득공제 신청서, 출자 또는 투자 확인서
                                  </div>
                                  <div>
                                    4) 국세청 연말정산 간소화자료 상세내역(한번에 내려받기 한 파일과 함께 제출하는 경우)
                                  </div>
                                  <div>
                                    <br/>
                                    파일형식 : 이미지파일(*.jpg, *.png), PDF파일, Office문서(*.xlsx, *.docx), ZIP파일
                                  </div>
                                </div>
                                <br/>
                                <div style={{ marginLeft: '25px' }}>
                                  <DropzoneArea
                                    acceptedFiles={[
                                      'application/pdf',
                                      'image/jpeg',
                                      'image/png',
                                      'application/vnd.ms-excel',
                                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                      'application/msword',
                                      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                      'application/zip',
                                      '.hwp'
                                    ]}
                                    filesLimit={20}
                                    dropzoneText={'파일을 선택하거나 또는 여기로 끌어 주세요.'}
                                    maxFileSize={30000000}
                                    // showFileNames={true}
                                    showPreviewsInDropzone={false}
                                    showAlerts={false}
                                    onDrop={handleChange}
                                    // onDelete={handleDelete}
                                    // initialFiles={kognrEtcFile && kognrEtcFile.map((file) => file.name)}
                                  />
                                  {etcReturnFiles && etcReturnFiles.map((file) => <DropzoneFileItem
                                    key={file.fileUuid} {...file} />)}
                                </div>
                              </div>
                            </div>
                    </Container>
                </div>
            </ScrollableAnchor>
        </>
    );
};

export default Survey16;
